/* eslint-disable @angular-eslint/directive-selector */
import { Directive, HostBinding, Input } from '@angular/core';

type MatTableSeperation = 'shaded' | 'divider' | 'alt';

@Directive({
  selector: 'mat-table, table[mat-table]',
  standalone: true,
})
export class MatTableAddonsDirective {
  @Input() seperation: MatTableSeperation = 'shaded';

  @HostBinding('class.mat-table-shaded') get isShaded() {
    return this.seperation === 'shaded';
  }

  @HostBinding('class.mat-table-divider') get isDivider() {
    return this.seperation === 'divider';
  }

  @HostBinding('class.mat-table-alt') get isAlt() {
    return this.seperation === 'alt';
  }
}
